<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="3">
        <v-card class="fill-height d-flex flex-column" outlined>
          <v-card-title>
            {{ title }}
          </v-card-title>

          <v-card-text>
            <v-form ref="form">
              <v-autocomplete label="Tipo de Perfil Gestor"
                v-model="params.tipoOrgaoGestor"
                :items="options.tipoOrgaoGestor"
                item-text="descricao" item-value="codigo"
                clearable dense
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn @click="reset()">Limpar</v-btn>
            <v-btn @click="addLayer()" color="#244EA2" dark>
              Pesquisar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" lg="9">
        <div :id="mapid" style="height: calc(100vh - 200px); width: 100%;"></div>
      </v-col>
      <v-col cols="12">
        <Gestor :codigo="codibge"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Gestor from './Gestor'
import axios from 'axios'
import * as L from 'leaflet'
import * as esri from 'esri-leaflet'
import { isString, uniqueId } from 'lodash'

import api from '@/api/vue-exemplo'
import { getBounds } from '@/domain/library'

export default {
  name: 'Orgao',
  components: {
    Gestor
  },
  data: () => ({
    mapid: null,
    title: 'Perfil Gestor',
    info: null,
    codibge: null,
    params: {
      tipoOrgaoGestor: []
    },
    options: {
      tipoOrgaoGestor: []
    }
  }),

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.onResize()
    })
  },
  mounted () {
    this.mapid = uniqueId()
    this.$nextTick(() => {
      this.map = L.map(this.mapid)
      this.map.fitBounds(getBounds())
      esri.basemapLayer('Topographic').addTo(this.map)

      L.Control.geocoder({
        position: "topleft",
        placeholder: "Pesquisar..."
      }).addTo(this.map)

      L.control.defaultExtent({
        title: 'Visão Inicial'
      }).addTo(this.map)

      api.getTipoOrgaoGestor()
        .then(response => {
          this.options.tipoOrgaoGestor = response.data
        })
        .catch(error => {
          console.log(error)
        })

      this.addLayer()
    })
  },
  methods: {
    reset () {
      this.$refs.form.reset()
      this.removeLayer()
    },
    getColor (value) {
      if (!isString(value)) {
        return '#a6cee3'
      }

      if (value.localeCompare('Secretaria') === 0) {
        return '#a6cee3'
      }

      if (value.localeCompare('Departamento') === 0) {
        return '#1f78b4'
      }

      if (value.localeCompare('Diretoria') === 0) {
        return '#b2df8a'
      }

      if (value.localeCompare('Autarquia') === 0) {
        return '#33a02c'
      }

      if (value.localeCompare('Fundação') === 0) {
        return '#fb9a99'
      }

      if (value.localeCompare('Sistema S') === 0) {
        return '#e31a1c'
      }

      if (value.localeCompare('Divisão') === 0) {
        return '#fdbf6f'
      }

      return '#a6cee3'
    },
    addLayer () {
      this.removeLayer()

      // Custom Info Control
      this.info = L.control()

      this.info.onAdd = function () { /* map */
        this._div = L.DomUtil.create('div', 'leaflet-info')
        this.update()
        return this._div
      }

      this.info.update = function (props) {
        this._div.innerHTML = '<h4>Perfil Gestor</h4>' + (props
          ? '<b>' + props.nomeorgao + '</b><br />' + props.descricaotipoorgaogestor
          : 'Passe o mouse sobre um município'
        )
      }

      this.info.addTo(this.map)

      var style = (feature) => { /* feature */
        return {
          fillColor: this.getColor(feature.properties.descricaotipoorgaogestor),
          weight: 2,
          opacity: 1,
          color: 'white',
          dashArray: '3',
          fillOpacity: 0.7
        }
      }

      var highlightFeature = (e) => {
        var layer = e.target
        layer.setStyle({
          weight: 5,
          color: '#666',
          dashArray: '',
          fillOpacity: 0.7
        })
        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront()
        }
        this.info.update(layer.feature.properties)
      }

      var resetHighlight = (e) => {
        this.geojson.resetStyle(e.target)
        this.info.update()
      }

      var click = (prop) => {
        this.codibge = prop.target.feature.properties.codibge
      }

      function onEachFeature (feature, layer) {
        var template = L.Util.template('<h2><strong>{nomeorgao}</strong></h2>' +
        '<p><strong>Município: </strong>{nome}<br/>' +
        '<p><strong>Tipo de órgão: </strong>{descricaotipoorgaogestor}<br/>' +
        '<p><strong>CNPJ: </strong>{cnpj}<br/>' +
        '<p><strong>Endereço: </strong>{endereco}<br/>' +
        '<p><strong>Número: </strong>{numero}<br/>' +
        '<p><strong>Complemento: </strong>{complemento}<br/>' +
        '<p><strong>Bairro: </strong>{bairro}<br/>' +
        '<p><strong>CEP: </strong>{cep}<br/>' +
        '<p><strong>Macroregional: </strong>{nomemacrorregional}<br/>' +
        '<p><strong>Regional: </strong>{nomeregional}<br/>' +
        '<p><strong>Consórcio: </strong>{nomeconsorcio}<br/>' +
        '<p><strong>Decreto: </strong>{decretolei_criacao}<br/>' +
        '</p>', feature.properties)

        layer.bindPopup(template)

        layer.on({
          mouseover: highlightFeature,
          mouseout: resetHighlight,
          click: click
        })
      }

      this.$store.commit('setLoading', true)

      var params = {
        service: 'wfs',
        version: '2.0.0',
        outputFormat: 'application/json',
        exceptions: 'application/json',
        request: 'GetFeature',
        typeNames: 'seec:orgaocultura_pol_p29192',
        srsName: 'EPSG:4674',
      }

      if(this.params.tipoOrgaoGestor.length != 0) {
        params.cql_filter = 'codigotipoorgaogestor=\'' + this.params.tipoOrgaoGestor + '\''
      }

      axios.get(process.env.VUE_APP_GEOSERVER, {
        params: params
      })
        .then(response => {
          this.geojson = L.geoJson(response.data, {
            style: style,
            onEachFeature: onEachFeature
          }).addTo(this.map)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.$store.commit('setLoading', false)
        })
      this.createLegend()
    },
    removeLayer () {
      if (this.geojson) {
        this.map.removeLayer(this.geojson)
        this.geojson = null
      }

      if (this.info) {
        this.map.removeControl(this.info)
        this.info = null
      }

      this.removeLegend()
    },
    createLegend () {
      this.legend = L.control({
        position: 'bottomright'
      })

      this.legend.onAdd = () => {
        var div = L.DomUtil.create('div', 'leaflet-info leaflet-legend'),
          colors = ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f'],
          labels = [
            'Secretaria',
            'Departamento',
            'Diretoria',
            'Autarquia',
            'Fundação',
            'Sistema S',
            'Divisão'
          ]

        for (var i = 0; i < colors.length; i++) {
          div.innerHTML += '<i style="background: ' + colors[i] +'"></i>'
          div.innerHTML += labels[i] + '<br>'
        }

        return div
      }

      this.legend.addTo(this.map)
    },
    removeLegend () {
      if (this.legend) {
        this.map.removeControl(this.legend)
        this.legend = null
      }
    },
    onResize () {
      if (this.map) {
        this.map.invalidateSize()
      }
    }
  }
}
</script>